// extracted by mini-css-extract-plugin
export default {"menu":"GlobalNav_menu__2ur4A","menuSp":"GlobalNav_menuSp__xVEC7","menuList":"GlobalNav_menuList__Dr1eY"};